import { Box, Typography } from "@mui/material";
import { LayoutContext } from '../../App';
import { useContext } from 'react';
import GameList from "./GameList";
import WhyText from "./WhyText";

const HomePage = () => {
    const { isMobile } = useContext(LayoutContext);

    return (
        <Box
            display="flex"
            flexDirection="column"
            gap={2}
            p={2}
            sx={{
                backgroundColor: '#1e1e1e'
            }}
        >
            <Box>
                <Typography variant="h4" align="center" >Сервис безопасной сделки между пользователями</Typography>
                <Typography variant="body1" align="center" >
                    Мы предоставляем сервис безопасной сделки между пользователями онлайн игр.
                    </Typography>
                    <Typography variant="body1" align="center" >
                    Платформа выступает гарантом выполнения обязательств между заказчиком и исполнителем.
                    </Typography>
                    <Typography variant="body1" align="center" >
                    Мы не являемся продавцом игровых ценностей и не продаём цифровые товары напрямую.
                </Typography>
            </Box>

            <Typography mt={1} mb={1} variant="h5" align="center">Выберите игру чтобы перейти к покупке</Typography>

            <GameList isMobile={isMobile} />

            <WhyText />

        </Box>
    );
};

export default HomePage;